/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgNbox = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M13 2v9h9v2h-9v9h-2v-9H2v-2h9V2zM9 20v2H6v-2zm-5 0v2H2v-2zm18 0v2h-2v-2zM8 16v2H2v-2zm14 0v2h-7v-2zm0-10v2h-4V6zM9 6v2H2V6zM6 2v2H2V2zm16 0v2h-7V2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgNbox as Nbox };
